import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faUserPlus, faAddressCard, faTintSlash, faUserLock, faHandHoldingHand, faUserMinus, faList } from '@fortawesome/free-solid-svg-icons';
import { StepsContext } from './Steps'; 

const Nav = (props) => { 

  const [menu, setMenu] = useState(false);
  const {setAction, Step, setStage, customer, setMessage, setCustomer, session, setChartData } = useContext(StepsContext);  

return (  
 
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
      <a className="navbar-brand" href="#">
        <img src="images/logo.png"/>
      </a>

      <button className="navbar-toggler" type="button" onClick={() => setMenu(!menu)}>
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className=" navbar-collapse justify-content-center" id="collapsibleNavbar">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" onClick={() => { Step.NewCustomer(); }}><FontAwesomeIcon icon={faUserPlus} /> New Customer</a>
          </li>
        
          <li className="nav-item">
            <a className="nav-link" onClick={() => { Step.SupplyDisruption(); }}><FontAwesomeIcon icon={faTintSlash} /> Supply Disruption</a>
          </li> 

          <li className="nav-item">
            <a className="nav-link" href="/supplier/login"><FontAwesomeIcon icon={faHandHoldingHand} /> Supplier Portal</a>
          </li> 

          {
            session ? 
            <li className="nav-item dashboard">
              <a className="nav-link" href={'/dashboard'}><FontAwesomeIcon icon={faList} /> Dashboard</a>
            </li> : ""
          }   
        </ul> 
      </div>  

      <ul className="nav navbar-nav navbar-right">
        { customer != "" ?
          <li><a className="btn btn-warning" onClick={() => { setStage(false);  setCustomer(""); setMessage([]); setChartData([]); }}><FontAwesomeIcon icon={faUserMinus} /> Logout</a></li>
          :
          <li><a className="btn btn-success" onClick={() => { Step.ExistingCustomer(); }}><FontAwesomeIcon icon={faUserLock} />  Customer Login</a></li> 
        }
      </ul>
    </div>
    
    { menu ?
    <div className="mobile-menu">
      <ul className="navbar-nav"> 
            <li className="nav-item">
              <a className="nav-link" onClick={() => { Step.NewCustomer(); }}><FontAwesomeIcon icon={faUserPlus} /> New Customer</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" onClick={() => { Step.SupplyDisruption(); }}><FontAwesomeIcon icon={faTintSlash} /> Supply Disruption</a>
            </li> 

            <li className="nav-item">
              <a className="nav-link" href="/supplier/login"><FontAwesomeIcon icon={faHandHoldingHand} /> Supplier Portal</a>
            </li> 

            {
              session ? 
              <li className="nav-item dashboard">
                <a className="nav-link" href={window.base_url}><FontAwesomeIcon icon={faHandHoldingHand} /> Dashboard</a>
              </li> : ""
            }   
            </ul> 
      </div> : "" }
  </nav>

    );
}

export default Nav;

